/**
 * 招待中企業の利用停止機能 (#2802) で使用する文字列定数
 * 複数画面で利用されるラベル・文言を集約
 */
export const suspendInvitedLabels = {
  /** 確定ボタン文言 */
  confirmButton: '変更する',
  /** 確定ボタン文言（処理中） */
  confirmButtonProcessing: '変更中...',
  /** 削除ボタン文言 */
  deleteButton: '削除する',
  /** 削除ボタン文言（処理中） */
  deleteButtonProcessing: '削除中...',
  /** キャンセルボタン */
  cancelButton: 'キャンセル',

  /** 企業 - 利用停止への変更ダイアログ */
  companySuspendDialogTitle: '利用停止への変更',
  companySuspendDialogBody: '招待中ステータスを利用停止に変更します。よろしいですか？',
  /** 企業 - 招待中に戻すダイアログ */
  companyRestoreDialogTitle: '契約ステータスを変更',
  companyRestoreDialogBody:
    'この企業を「招待中」に戻します。ユーザーは再びログインできるようになります。',
  /** 企業 - 削除確認ダイアログ */
  companyDeleteDialogTitle: '企業の削除',
  companyDeleteDialogBody:
    'この企業を削除します。削除すると一覧から非表示になり、招待メールも無効になります。よろしいですか？',
  /** 企業 - 成功スナックバー（ステータス変更） */
  companyChangeSuccess: '契約ステータスを変更しました。',
  /** 企業 - 失敗スナックバー（ステータス変更） */
  companyChangeError: '契約ステータスの変更に失敗しました。',
  /** 企業 - 成功スナックバー（削除） */
  companyDeleteSuccess: '企業を削除しました。',
  /** 企業 - 失敗スナックバー（削除） */
  companyDeleteError: '企業の削除に失敗しました。',
} as const;
